import React, {useEffect} from 'react';
import {MountableModal} from '@components/molecules';
import {inAppBrowser} from '@helpers';
import {ReferralsShareBanner, Section} from '@views/Referrals';
import {BANNER_TYPE} from '@lookiero/aurora';

type ReferralsShareDialogProps = {
  isVisible: boolean;
  onClose: () => void;
  setParentLayoutScrollEnabled: (enabled: boolean) => void;
};

export const ReferralsShareDialog: React.FC<ReferralsShareDialogProps> = ({
  isVisible,
  onClose,
  setParentLayoutScrollEnabled = () => undefined,
}) => {
  useEffect(() => {
    // the following is required to lock the parent Layout scroll in Facebook browser
    if (inAppBrowser) setParentLayoutScrollEnabled(!isVisible);
  }, [isVisible, setParentLayoutScrollEnabled]);

  return (
    <MountableModal
      portalID="modal-referral-portal"
      isVisible={isVisible}
      onClose={onClose}
      nativeID="modal-referral"
      testID="share-modal"
    >
      <ReferralsShareBanner section={Section.PLACED_ORDER_VIEW} bannerType={BANNER_TYPE.ROUNDED} />
    </MountableModal>
  );
};
